import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth15: ToothDataEntry = {
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M31.1,145.2l-5.8-12.6-3.6-9-4.7-18.9-1.5-11.8.2-16.6,1.8-6.2,3.8-9.8,4.7-6.2,10.6-11,11.3-9.4,12.6-5.8,9.4-3.4h13.6s4.5,1.5,4.5,1.5l16.2,7.3,15.6,11,7.9,8.4,5.1,10.6-.2,15.1-6,32.5-11.1,38.8s-45.1,21.4-84.4-4.5Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M31.2,145.2c41.1,26.6,84.4,4.5,84.4,4.5l9.8-34.5-20,.2c-10.8,0-10.6-9.1-10.6-9.1l.2-41.9-41.9.2.2,41.2c0,9.3-11.3,8.4-11.3,8.4h-23.3s3,9.4,3,9.4l3.6,9,5.8,12.6h.1Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M94.6,106.3c-.2,10.1,10.6,9.1,10.6,9.1l20-.2,9-39.2-.5-12.9-3.8-8.8-7.7-8.6-12.7-10-14.6-8.1v36.8s-.2,41.9-.2,41.9h-.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M42,114.2h-23.3s-2.5-11.1-2.5-11.1l-.7-7.9v-18.3s2.5-10.9,2.5-10.9l5.2-9.5,8.1-9,10-9.5,12-8.4v76.2c0,9.2-11.3,8.4-11.3,8.4Z',
			},
			[ToothSurface.PalatalCusp]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '133.2 64.1 132.8 60.6 130.4 54.2 124.8 47.5 120.1 43.6 114.6 39.1 110.5 36.6 104.8 32.1 96.8 27.8 90.4 25.8 83.5 23.5 79.8 23.5 73 23.3 66.7 24.8 56.9 27.6 50.1 31.1 45 34.4 36 42.4 29.2 48.9 23.1 56.7 18 64.4 53.1 64.4 95 64.4 133.2 64.1',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M113.8,158.1c-45.3,24.6-80.1-3.7-80.1-3.7l-2.6-9.2c41.3,25.6,84.4,4.5,84.4,4.5,0,0-1.7,8.4-1.7,8.4Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M31.1,145.2l-5.8-12.6-3.6-9-4.7-18.9-1.5-11.8.2-16.6,1.8-6.2,3.8-9.8,4.7-6.2,10.6-11,11.3-9.4,12.6-5.8,9.4-3.4h13.6s4.5,1.5,4.5,1.5l16.2,7.3,15.6,11,7.9,8.4,5.1,10.6-.2,15.1-6,32.5-11.1,38.8s-45.1,21.4-84.4-4.5Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'16 81.7 28.9 100.9 32.4 74 44.1 106 52.8 74 63.6 107.7 73.5 76.1 84.3 107.7 93.9 75.8 104.3 107.7 112.4 76.6 118.4 102.2 130.5 83.9',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'60.1 393.2 66.8 374.6 55.8 364.7 68.9 357.7 57.8 346.9 70.6 338.7 59.5 330.3 73 323.6 59.2 313.4 74.3 306.8 61 297.9 75.6 291.2 64.5 280.2 78.5 274.3 66 265.6 79.3 258.6 67.9 249.4 80.3 245.5 69.6 238.1 79.8 230.9 69.1 223.5 81.9 214.4 70.8 206.8 81.9 198.8 70.6 191 83 182.2 71.1 173.8 84.3 164.1 72.7 156.1',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'45.6 256.5 51.3 268.7 57.1 256.2 63.9 269.8 70.8 256.2 76.6 270.5 82.9 258.6 88.2 268.7 92.7 257.7 96.9 269.8 100.5 258.3',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '124.4 107.8 117.5 122.9 103.9 142.4 94.6 155.1 88.3 160.7 79.7 165.9 70.4 169.1 56.2 168.9 45.6 165 36.8 158.8 29.9 149.3 22.8 136.3 18.2 123.8 15.9 113.5 14.8 104.2 14.6 90.4 15.2 86.5 16.5 80.7 19.3 74.4 23 67.9 27.1 61.9 34 54.6 43 49 52.3 45.7 63.7 42.9 80.8 43.3 91.1 45.3 101.1 49.4 110.1 54.8 118.1 62.5 125 71.4 129.3 80.4 129.1 93 124.4 107.8',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M126.8,75.9l-4.7-10.5-7.3-7.6-8.4-6.8-10.5-4.7-11.3-3.5-9.5-.7h-13s-9.3,2.4-9.3,2.4l-11.3,4.4-7.6,5.1-5.7,5.6-6.2,8.1-3.9,9s5.2,10.2,22.3,17.1c17.1,6.9,20.8-6.2,30.6-6.2s15.6,10.6,28.5,6.9,27.4-18.4,27.4-18.4v-.2Z',
			},
			[ToothSurface.PalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M20.9,133.6l5.1,9.8,8.6,13.7,11.1,8.4,9.8,3.2,15.7.2,11.7-3.7,9.3-7.3,7.9-8.3,10.1-15.2s-5-9.4-19.1-12.8-13.9,6.8-23,6.8c-9.1,0-11.5-9.1-23.6-6.2s-23.6,11.5-23.6,11.5h0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M126.8,76.1l-20.1,15.2c-21.4,18.4-3.5,36.6-3.5,36.6l6.9,6.6,8.6-15,7.3-15.7,2.9-10v-12.3s-2-5.4-2-5.4h-.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M18.3,76.7l14,12.7c28.8,22.2-.8,38.2-.8,38.2l-10.5,6.1-5.6-17.4-1.4-11.3.2-14,1.5-8.6,2.5-5.6h0Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M106.8,91.2s-9.1,7.7-9.1,15.3,4.3,19.9,4.3,19.9c0,0-.8-2.1-10.9-4.9-10.1-2.8-14.8,6.8-23,6.8-8.2,0-14.3-8.7-23.6-6.2-9.3,2.5-13.2,5.4-13.2,5.4,28.8-18.1,2.2-36.9,2.2-36.9l6.9,3.2c19.1,6.9,19.7-6.9,30.6-6.2s12.5,9,28.5,6.9l7.3-3.2h0Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M127,76.2c-82.2-27.3-108.8.7-108.8.7l3.9-9,6.2-8.1,5.7-5.6,7.6-5.1,11.3-4.4,9.3-2.4h13s9.5.7,9.5.7l11.3,3.5,10.5,4.7,8.4,6.8,7.3,7.6,4.7,10.5h.1Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M110.3,134.5c-48.6,35.5-89.3-.8-89.3-.8l5.1,9.8,8.6,13.7,11.1,8.4s10,4.1,10,4.2h14.1s13-4.5,13-4.5l9.3-7.3,7.9-8.3,10.1-15.2h.1Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'14.8 95.7 26.3 110.8 32 89.7 39.7 115.5 49.6 89.1 59 115.5 69.1 89.4 78.7 115.5 89 87.8 97.5 114.3 108.4 87.8 111.9 109.9 126 96.4',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M122.6,370.7c-52.5-39.1-93.2,6.9-93.2,6.9l-7,20.5-7.3,21.3-.2,20.2,4.3,10.3,10.6,17,14.8,12.6,24.5,11.2,14.4-.4,22.7-7.6,17.9-11.5,9.1-11.9,1.8-11.5-3-27.5-2.8-21.3-6.5-28.2h-.1Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M122.7,370.8l8.2,35.9h-19.5c-14.8,0-16.2,13.5-16.2,13.5v34.1h-39.4v-34.3c0-14.4-20.6-13.9-20.6-13.9h-15.6s9.9-28.4,9.9-28.4c47.4-46.7,93.2-6.9,93.2-6.9h0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M130.9,406.8h-19.5c-15.7,0-16.2,13.5-16.2,13.5v34.1s-.2,33-.2,33l20.2-10.3,10.7-7.5,6.6-9.4,2.3-8.9-3.9-44.6h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M19.6,406h15.6c22.7,0,20.6,13.9,20.6,13.9v34.3s-.7,31.1-.7,31.1l-18.3-13.1-15.8-19.4-5-12.4-.4-12.3,1.2-9.4,2.7-12.6h.1Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '21.9 454.6 30.3 464.9 42.2 476.8 56.8 486.2 69.8 490.1 82.2 490.3 91.3 488.2 108.3 481.1 121.1 473.3 131 462.8 134.1 454.3 95.2 454.3 55.7 454.3 21.9 454.6',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M122.6,370.7c-52.5-39.1-93.2,6.9-93.2,6.9l-7,20.5-7.3,21.3-.2,20.2,4.3,10.3,10.6,17,14.8,12.6,24.5,11.2,14.4-.4,22.7-7.6,17.9-11.5,9.1-11.9,1.8-11.5-3-27.5-2.8-21.3-6.5-28.2h-.1Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M122.7,370.7l-2-8.9c-49.3-42.1-86.3,4.7-86.3,4.7l-4.9,11.2c48.4-45.2,93.2-6.9,93.2-6.9h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'132.3 431.8 120.1 414.8 116.7 441.1 105.4 409.8 96.8 441.1 86.3 408.1 76.7 439.1 66.2 408.1 56.8 439.5 46.7 408.1 38.9 438.6 33.2 413.6 17.2 435.3',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'66.2 102.9 62.5 120.2 75.3 129.3 64.5 138.8 77.7 149.3 62.9 157 78.7 167 64.1 176.6 80.2 186.8 65.7 196.3 82.1 206.6 67.2 216.4 81.3 225.3 69 233.4 83.4 242.2 70.1 250.9 84.3 259.9 70.4 269.1 83.9 277.7 71 285.9 84.7 294.5 68.4 304.9 82.4 313.6 68.4 322.9 82.6 331.7 67 341.9 82.1 351.6 65.3 362.7 82.3 376.5',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'110.4 256.3 105.4 240.3 98.4 256.1 92.6 238.7 86 255.6 78 238.7 70.1 255.1 64.5 239.5 58.7 255 50.8 239 47.3 254.8',
			],
		},
	},
};
